<template>
    <div
        class="navbar__wrapper"
        :class="{'active' : navbarOpened}"
    >
        <aside
            class="navbar"
            :class="{'navbar--active' : navbarOpened}"
            @click="closeNavbar"
        >
            <nav v-body-scroll-lock="locked" class="navbar__menu">
                <template v-for="item in MENU_ITEMS" :key="item.label">
                    <router-link
                        v-if="item.role.find(el => el === me.role)"
                        :to="{ name: item.to }"
                        :title="$t(`${item.label}`)"
                        rel="noopener noreferrer"
                        class="navbar__link"
                        active-class="navbar__link--active"
                        @click="closeNavbar"
                    >
                        <SvgIcon class="navbar__link-icon" :name="item.icon" />

                        <transition name="fade-enter-transition">
                            <span v-show="navbarOpened" class="navbar__link-label">
                                {{ $t(`${item.label}`) }}
                            </span>
                        </transition>
                    </router-link>
                </template>
            </nav>

            <div class="navbar__controls">
                <RowButton
                    :icon="isDark ? 'dark_mode' : 'light_mode'"
                    @click.stop="toggleDark()"
                />

                <LanguagesSelect v-if="isSm" @click.stop />
            </div>
        </aside>
    </div>
</template>

<script>
export default {
    name: 'NavbarMenu',
};
</script>

<script setup>
import { inject, onBeforeUnmount, onMounted, ref } from 'vue';
import { useDark, useToggle } from '@vueuse/core';
import { emitter } from '@/main';
import { toggleColor } from '@/composables/use-toggle-color';
import { MENU_ITEMS } from '@/constants/navbar-menu';
import RowButton from '@/components/ui/buttons/RowButton';
import LanguagesSelect from '@/components/ui/LanguagesSelect';
import SvgIcon from '@/components/ui/SvgIcon';

const { me } = inject('me');

const isSm = inject('isSm');

const isDark = useDark(toggleColor);
const toggleDark = useToggle(isDark);

const navbarOpened = ref(false);
const locked = ref(false);

const onToggleNavbar = ({ force } = {}) => {
    navbarOpened.value = force ?? !navbarOpened.value;
    locked.value = force ?? !locked.value;
};

const closeNavbar = () => {
    if (!navbarOpened.value) return;
    onToggleNavbar();
    emitter.emit('click-navbar-item');
};

onMounted(() => {
    emitter.on('toggle-navbar', onToggleNavbar);
});

onBeforeUnmount(() => {
    emitter.off('toggle-navbar', onToggleNavbar);
});
</script>

<style src="./styles.scss" lang="scss" />
